/**
 * Shared Bootstrap button variants for embed-forms UI.
 * Primary / secondary match common app patterns; danger uses the Dashboard
 * `.btnDanger` palette via `embed-form-editor.css`.
 */
export const EmbedFormBtn = {
    primary: "primary",
    secondary: "outline-primary",
    neutral: "outline-secondary",
    danger: "outline-danger",
};
